import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import { getLanguageValue } from "locales/i18n";
import { PAGE_TYPE } from "enums";

const TermsComponent = (props: any) => {
    const { info, list } = props;

    const navigate = useNavigate();

    return (
        <main className="bg-gray-50 min-h-screen py-6">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                {/* 헤더 */}
                <div className="flex items-center gap-4 mb-6">
                    <button
                        onClick={() => navigate("/student/my")}
                        className="text-gray-600 hover:text-gray-900"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>
                    <h1 className="text-2xl font-bold text-gray-900">
                        {getLanguageValue(PAGE_TYPE.STUDENT, "my.txtSectionTermsTitle")}
                    </h1>
                </div>

                {/* 약관 내용 */}

                {info ? (

                    <div className="terms">
                        <div className="con">
                            <div className="content">
                                {info?.version >= 2 ? (
                                    <>
                                        <ReactMarkdown>{info?.text || ""}</ReactMarkdown>
                                    </>
                                ) : (
                                    <>

                                        <div dangerouslySetInnerHTML={{
                                            __html: info?.text,
                                        }} />


                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                ) : (
                    <div className="prose prose-sm max-w-none">
                        <div className="bg-white rounded-2xl p-6 shadow-sm mb-6">
                            <div className="flex flex-col items-center justify-center py-12">
                                <p className="text-gray-500 text-lg">
                                    {getLanguageValue(PAGE_TYPE.STUDENT, "my.txtNoTermsAvailable")}
                                </p>
                            </div>
                        </div>
                    </div>
                )}


                {/* 약관 목록 */}
                <div className="bg-white rounded-2xl p-6 shadow-sm">
                    <h3 className="text-lg font-semibold mb-4 text-gray-900">
                        {list.map((item: any) => (
                            <div key={`term-${item.id}`}>
                                {item.id === info?.id
                                    ?
                                    <span className='text-xs text-gray-500'>{item.title}({item.applyDate})</span>
                                    :
                                    <Link className='text-xs text-gray-500' to={`/student/my/terms/${item.id}`}>{item.title}({item.applyDate})</Link>}
                            </div>
                        ))}
                    </h3>
                </div>
            </div>
        </main >
    );
};

export default TermsComponent;
